module.exports = __webpack_public_path__ + "img/after9.6fff3be5.png";